webpackJsonp([50739212244294],{

/***/ 284:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(51);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Tags = function Tags(_ref) {
	  var pathContext = _ref.pathContext,
	      data = _ref.data;
	  var tag = pathContext.tag;
	  var _data$allMarkdownRema = data.allMarkdownRemark,
	      edges = _data$allMarkdownRema.edges,
	      totalCount = _data$allMarkdownRema.totalCount;
	
	  var tagHeader = totalCount + " post" + (totalCount === 1 ? "" : "s") + " tagged with \"" + tag + "\"";
	
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      "h2",
	      null,
	      totalCount,
	      " post",
	      totalCount === 1 ? "" : "s",
	      " tagged with '",
	      tag,
	      "'."
	    ),
	    _react2.default.createElement(
	      "ul",
	      null,
	      edges.map(function (_ref2) {
	        var node = _ref2.node;
	        var _node$frontmatter = node.frontmatter,
	            path = _node$frontmatter.path,
	            title = _node$frontmatter.title;
	
	        return _react2.default.createElement(
	          "li",
	          { key: path },
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: path },
	            title
	          )
	        );
	      })
	    ),
	    _react2.default.createElement(
	      _gatsbyLink2.default,
	      { to: "/tags" },
	      "All tags"
	    )
	  );
	};
	
	exports.default = Tags;
	var pageQuery = exports.pageQuery = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-tags-js-f0996826c11c41a9a8c6.js